import { useTheme } from '@mui/styles';

import {
  CELL_FONT_SIZE,
  DAY_GRAY,
  LEFT_COLUMN,
} from '~/components/EmployeeCalendar/data';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      overflow: 'hidden',
    },
    tableWrapper: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    footerWrapper: {
      borderTop: `1px solid ${DAY_GRAY}`,
    },
    leftCells: {
      width: `${LEFT_COLUMN}px`,
      alignSelf: 'flex-end',
      fontWeight: 'bold',
      flexShrink: 0,
      fontSize: CELL_FONT_SIZE,
    },
    rightCells: {
      flexGrow: 1,
      overflow: 'hidden',
      marginBottom: '-1px',
    },
    calendarHeaderWrapper: {
      width: '100%',
      display: 'flex',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      borderBottom: `1px solid ${DAY_GRAY}`,
    },
    minLeftCell: {
      width: '50px',
      alignSelf: 'flex-end',
      fontWeight: 'bold',
      flexShrink: 0,
      overflow: 'hidden',
      paddingRight: theme.spacing(1),
      fontSize: '14px',
    },
    loadingView: {
      minHeight: theme.spacing(4.25),
    },
  };
};
